import { render } from "./ArcDiagram.vue?vue&type=template&id=08a94585"
import script from "./ArcDiagram.vue?vue&type=script&lang=ts"
export * from "./ArcDiagram.vue?vue&type=script&lang=ts"
script.render = render

export default script